import { useContext } from 'react';
import ClientContext from 'shared/src/components/contexts/ClientContext';

const useClient = () => {
  const client = useContext(ClientContext);
  return client;
};

export default useClient;
